import { styled } from "leva/plugin";

export const StyledScrollbar = styled("div", {
	display: "flex",
	width: "100%",
	height: "100%",
	alignItems: "center",
	gap: "4px",
	overflowX: "auto",
	overflowY: "hidden",
	padding: "0px 4px",

	// WebKit-based browsers (Chrome, Safari, etc.)
	"&::-webkit-scrollbar": {
		width: "1px",
		height: "1px",
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: "rgba(96, 165, 250, 1)",
	},
	"&::-webkit-scrollbar-track": {
		backgroundColor: "transparent",
	},

	// Firefox
	scrollbarWidth: "thin",
	scrollbarColor: "rgba(96, 165, 250, 1) transparent",

	// Internet Explorer and Edge
	MsOverflowStyle: "none",
});
